export default __webpack_public_path__ + "static/media/open-projects-empty-state.d6d0e56a.svg";